import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Section } from '../questionnaire.component';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MoveNumberToFrontPipe } from 'src/app/move-number-to-front.pipe';

@Component({
    selector: 'app-section-overview-dialog',
    standalone: true,
    imports: [
      CommonModule,
      MatDialogModule,
      MatListModule,
      MatIconModule,
      MatButtonModule,
      MoveNumberToFrontPipe
    ],
    templateUrl: './section-overview.component.html',
    styleUrls: ['./section-overview.component.scss']
  })
  export class SectionOverviewDialogComponent {
    constructor(
      public dialogRef: MatDialogRef<SectionOverviewDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: { sections: Section[], selectedSection: Section }
    ) {}
  
    select(section: Section): void {
      this.dialogRef.close(section);
    }
  
    close(): void {
      this.dialogRef.close();
    }    

  }